<template>
    <div class="topbar">
        <!-- LOGO -->
        <div class="topbar-left">
            <a href="/" class="logo">
                <span>
                    <!-- <img src="@/assets/custom-images/logo-sm.png" alt="logo-small" class="logo-sm"> -->
                </span>
                <span>
                    <img :src="showLogo" alt="logo-large" class="logo-sm logo-header-left">
                </span>
            </a>
        </div>
        <!--end logo-->
        <!-- Navbar -->
        <nav class="navbar-custom">
            <ul class="list-unstyled topbar-nav float-right mb-0">
                <!-- <li class="dropdown notification-list">
                    <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#" role="button"
                        aria-haspopup="false" aria-expanded="false">
                        <i class="dripicons-bell noti-icon"></i>
                        <span class="badge badge-danger badge-pill noti-icon-badge">2</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-lg">
                        <h6 class="dropdown-item-text">
                            Notifications (18)
                        </h6>
                        <div class="slimscroll notification-list">
                            <a href="javascript:void(0);" class="dropdown-item notify-item active">
                                <div class="notify-icon bg-success"><i class="mdi mdi-cart-outline"></i></div>
                                <p class="notify-details">Your order is placed<small class="text-muted">Dummy text of the printing and typesetting industry.</small></p>
                            </a>
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <div class="notify-icon bg-warning"><i class="mdi mdi-message"></i></div>
                                <p class="notify-details">New Message received<small class="text-muted">You have 87 unread messages</small></p>
                            </a>
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <div class="notify-icon bg-info"><i class="mdi mdi-glass-cocktail"></i></div>
                                <p class="notify-details">Your item is shipped<small class="text-muted">It is a long established fact that a reader will</small></p>
                            </a>
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <div class="notify-icon bg-primary"><i class="mdi mdi-cart-outline"></i></div>
                                <p class="notify-details">Your order is placed<small class="text-muted">Dummy text of the printing and typesetting industry.</small></p>
                            </a>
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <div class="notify-icon bg-danger"><i class="mdi mdi-message"></i></div>
                                <p class="notify-details">New Message received<small class="text-muted">You have 87 unread messages</small></p>
                            </a>
                        </div>
                        <a href="javascript:void(0);" class="dropdown-item text-center text-primary">
                            View all <i class="fi-arrow-right"></i>
                        </a>
                    </div>
                </li> -->


                <li class="dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown"
                        href="#" role="button" aria-haspopup="false" aria-expanded="false">
                        <img src="@/assets/custom-images/user.svg" alt="profile-user" class="rounded-circle" />
                        <span class="ml-2 nav-user-name hidden-sm" style="text-transform: capitalize"> 
                            {{$store.state.userData ? $store.state.userData.name : username}}
                        <i class="mdi mdi-chevron-down"></i> </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <!-- <a class="dropdown-item" href="#"><i class="dripicons-user text-muted mr-2"></i> Profile</a> -->
                        <!-- <a class="dropdown-item" href="#"><i class="dripicons-gear text-muted mr-2"></i> Settings</a> -->
                        <!-- <div class="dropdown-divider"></div> -->
                        <a class="dropdown-item" href="#" @click.prevent="gotoProfile()" v-if="$cookies.get('type_user_login') == 'instance'"><i class="dripicons-user text-muted mr-2"></i> Profile</a>
                        <a class="dropdown-item" href="#" @click.prevent="signOut()"><i class="dripicons-exit text-muted mr-2"></i> Logout</a>
                    </div>
                </li>
            </ul>
            <!--end topbar-nav-->

            <ul class="list-unstyled topbar-nav mb-0">
                <li>
                    <button 
                        style="border: none; width: 60px; background-color: transparent"
                        class="nav-link waves-effect waves-light" @click.prevent="toogleMenu">
                        <i class="dripicons-menu nav-icon"></i>
                    </button>
                </li>
            </ul>
        </nav>
        <!-- end navbar-->
    </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
    computed: {
        showLogo(){
            if($cookies.get('type_user_login') == 'instance'){
                return this.$store.state.userData.company_logo
            }else if($cookies.get('type_user_login') == 'admin'){
                return require('@/assets/custom-images/logo-sm.png')
            }else{
                return require('@/assets/custom-images/logo-sm.png')
            }
        },
        logoutMode() {
            if($cookies.get('type_user_login') == 'instance'){
                return 'instanceLogin'
            }else if($cookies.get('type_user_login') == 'admin'){
                return 'adminLogin'
            }else{
                return 'groupLogin'
            }
        },
        username() {
            if($cookies.get('type_user_login') == 'instance'){
                return $store.state.userData.name ? $store.state.userData.name : '-'
            }else if($cookies.get('type_user_login') == 'admin'){
                return $cookies.get('data_admin').name
            }else{
                return $cookies.get('data_group').name
            }
        }
    },
    methods: {
        gotoProfile(){
            this.$router.push(
                { name: 'instanceSettings' }
            );
        },
        signOut(){
            Swal.queue([{
                title: 'Anda Yakin Ingin Keluar ?',
                confirmButtonText: 'Ya, Keluar',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                showCancelButton: true,
                preConfirm: () => {
                    const token = this.$cookies.get("token_instance") ? this.$cookies.get("token_instance") : this.$cookies.get("token_admin")
                    this.$http.post(`${this.API_URL}auth/company/logout`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    })
                    .then(response => {
                        this.$cookies.remove('token_instance')
                        this.$cookies.remove('token_admin')
                        this.$cookies.remove('data_instance')
                        this.$cookies.remove('data_admin')

                        this.$router.push(
                            { name: this.logoutMode }
                        );

                        setTimeout(() => {
                            this.$cookies.remove('type_user_login');
                        }, 300);
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingInitial = false;
                    });
                }
            }])
            
        },
        toogleMenu(){
            if($('body').hasClass('enlarge-menu')){
                $('body').removeClass('enlarge-menu');
            }else{
                $('body').addClass('enlarge-menu');
            }
        }
    },
    mounted() {
    }
}
</script>>